/**
 * This function tests that common browser APIs we rely on are available, if not
 * it will return false. It should only test for features critical for the page
 * to function. Add tests here for issues that have been seen in the wild.
 */
export const isBrowserLackingCriticalFunctionality = () => {
  let error = false;
  // Proper dialog support is required for most popups and modals and dropdowns.
  try {
    const dialog = document.createElement("dialog");
    document.body.appendChild(dialog);
    dialog.showModal();
    dialog.open = false;
    document.body.removeChild(dialog);
  } catch {
    console.error("Dialog not supported");
    error = true;
  }

  // Check that we have some Intl support.
  try {
    // @ts-expect-error supportedValuesOf is not yet in TS lib typings.
    Intl.supportedValuesOf("calendar");
  } catch {
    console.error("Intl.supportedValuesOf() not supported");
    error = true;
  }

  return error;
};

/**
 * This function should test to see if the browser qualifies for support in the
 * `@sinch/browserslist-config` package. However many other versions may work as
 * well. If there are no critical features missing this function is to let users
 * know that we do not explicitly support this browser but that it may still
 * work, with or without some degradation.
 * @TODO: Implement (and use) this check to display a banner...
 */
export const isBrowserOld = () => false;
